module.exports = require("lodash.xor");